import { PermanentError } from './errors';

// get tenant name from subdomain (first part)
export function getTenantNameBySubdomain() {
  const hostMatchRegExp = /^([\d_a-z-]+)\./;

  const hostMatch = hostMatchRegExp.exec(globalThis.location.hostname);

  if (hostMatch?.[1] == null) {
    throw new PermanentError('Could not extract tenant name from URL');
  }

  // Temporary solution to be able to access portal classic tenants from portal-next.
  // e.g. customer-next.asset-metrix.com uses the poco configuration for tenant 'customer'.
  return hostMatch[1].replace(/-next$/i, '');
}
